import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Slider from 'react-slick'
import s from './index.css';
import Link from '../../common/Link'
import BlurImg from '../../common/BlurImg'
import { trackEventLog } from '../../../core/utils'
import bannerDefault from '../../common/static/bannerDefault.jpg'

const slideSetting = {
  dots: true,
  arrows: false,
  infinite: false,
  autoplay: false,
  slidesToShow: 1,
  slidesToScroll: 1,
}

const slickDotsStyle = `
  .comp-slide .slick-slider {
    position: relative;
  }
  .comp-slide .slick-dots button {
    display: none;
  }
  .comp-slide .slick-dots{
    position:absolute;
    height: 2px;
    top: 338px;
    left: 0;
    width: 1180px;
    text-align: center;
  }
  .comp-slide .slick-dots li{
    display: inline-block;
    height: 2px;
    width: 80px;
    background: #F7FFFF;
    line-height: 2px;
    vertical-align: top;
    margin: 0 2px;
    border-radius: 2px;
  }
  .comp-slide .slick-dots .slick-active {
    background: #EE4137;
  }
  .comp-slide .slick-arrow {
    position: absolute;
    top: 150px;
    height: 48px;
    width: 48px;
    background: rgba(0, 0, 0, 0.1);
    z-index: 10;
    cursor: pointer;
  }
  .comp-slide .slick-slider:hover .slick-arrow {
    display: block !important;
  }
  .comp-slide .slick-prev {
    left: -60px;
    background: url('https://ydschool-video.nosdn.127.net/1728517423465%E5%B7%A6%E6%8C%89%E9%92%AE_%E9%BB%98%E8%AE%A4%402x.png') center center no-repeat;
    background-size: 48px 48px;
  }
  .comp-slide .slick-arrow:hover {
    background: url('https://ydschool-video.nosdn.127.net/1728517399651%E7%82%B9%E5%87%BB%402x.png') center center no-repeat;
    background-size: 48px 48px;
  }
  .comp-slide .slick-next {
    right: -60px;
    background: url('https://ydschool-video.nosdn.127.net/1728517426135%E5%8F%B3%E6%8C%89%E9%92%AE_%E9%BB%98%E8%AE%A4%402x.png') center center no-repeat;
    background-size: 48px 48px;
  }
  .comp-slide .slick-next:hover {
    background: url('https://ydschool-video.nosdn.127.net/1728517414909%E7%82%B9%E5%87%BB%402x.png') center center no-repeat;
    background-size: 48px 48px;
  }
  .comp-slide img {
    border-radius: 20px;
  }
`


class Slide extends React.Component {

  static propTypes = {
    banners: PropTypes.array.isRequired,
    inLocPrefix: PropTypes.string.isRequired,
    inLocPosfix: PropTypes.string,
    tagId: PropTypes.string,
  }

  static defaultProps = {
    inLocPosfix: '',
    tagId: '',
  }

  render() {
    const { banners, tagId } = this.props
    let settings = slideSetting
    if (banners.length > 1) {
      settings = Object.assign({}, slideSetting, {
        infinite: true,
        speed: 500,
        arrows: true,
        autoplay: true,
        prevArrow: <div {...this.props} />,
        nextArrow: <div {...this.props} />,
      })
    }
    const style = `
      ${slickDotsStyle}`
    return (
      <div className={'comp-slide'}>
        <style dangerouslySetInnerHTML={{ __html: style.replace(/\t|\s{2,}/gi, '') }} />
        {banners.length > 0 && <Slider {...settings}>
          {banners.map((banner, inx) => {
            const handledUrl = (banner.url && banner.type === 'video') ? `https://c.youdao.com/d/videojs.html?video=${banner.url}` : banner.url
            return (
              <Link
                // 没有id的数据通过特殊前缀+索引来保持唯一性
                key={`slide_${banner.id ? banner.id : `index_${inx}`}`}
                to={handledUrl}
                target={'_blank'}
                rel={'noopener noreferrer'}
                className={s.link}
                extraParams={{ inLoc: tagId ? 'web_tag_banner' : 'web_home_banner', Pdt: 'jpkWeb' }}
                onClick={() => { trackEventLog(tagId ? `w/tag/${tagId}/head/${inx}` : `w/index/slider/click/${inx}`) }}
              >
                <BlurImg
                  addStyle={s.img}
                  placeHolder={bannerDefault}
                  originSrc={banner.img}
                  altText={banner.title}
                />
              </Link>
            )
          })}
        </Slider>}
      </div>
    );
  }
}

export default withStyles(s)(Slide);



// WEBPACK FOOTER //
// ./src/components/common/Slide/index.js